import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Icon, Loader, ViewContext } from "@/components/lib";
import Styles from "@/css/mainStyles";
import axios from "axios";

export default function VerifyEmailModal({ id, setOpen }) {
  const viewContext = useContext<any>(ViewContext);
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const VerifyEmailSubmit = async (data) => {
    setLoading(true);
    try {
      await axios({
        method: "get",
        url: "/api/otp/" + data.code
      });
      setSent(true);
      viewContext.notification.show("Email verified", "success");
      setOpen(false);
    } catch (error) {
      console.error(error);
      viewContext.notification.show(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return sent ? (
    <div className="flex flex-col text-center justify-center">
      <Icon image="check-circle" size={50} className="mx-auto text-green-500" />
      <h2 className="text-lg md:text-2xl font-bold mb-2">
        Your Email Has Been Verified!
      </h2>
      <h3 className="text-sm md:text-lg mb-4">
        Your new email address has been successfully verified. You now have full
        access to your account without interruption.
      </h3>
      <button onClick={() => setOpen(false)} className={Styles.cancelButton}>
        Close
      </button>
    </div>
  ) : (
    <form onSubmit={handleSubmit(VerifyEmailSubmit)}>
      <h2 className="text-lg md:text-2xl font-bold mb-2">Verify your Email</h2>
      <h3 className="text-sm md:text-2xl mb-4">
        We just sent a 6-digit code to your email, enter it below.
      </h3>

      <div className="flex flex-col gap-2">
        <label className="text-sm lg:text-2xl text-black font-medium ml-2 mb-2">
          Code
        </label>
        <input
          type="text"
          className={Styles.input}
          {...register("code", { required: true })}
        />
        {errors.code && (
          <span className="text-red-500 text-sm">Code is required</span>
        )}
      </div>

      <div className="flex justify-between mt-4 gap-4">
        <button onClick={() => setOpen(false)} className={Styles.cancelButton}>
          Cancel
        </button>

        <button className={Styles.submitButton}>
          Continue {loading && <Loader />}
        </button>
      </div>
    </form>
  );
}
